import { render } from "./Busqueda.vue?vue&type=template&id=ae87f5bc"
import script from "./Busqueda.vue?vue&type=script&lang=js"
export * from "./Busqueda.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wServer\\app-pagos-elroble\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__